import "./List.css";

import { Button, Column, CursorDataGrid, Row } from "../../../../../widget";
import { AddEditCompanyModal } from "../panels/AddEditCompanyModal";
import { CompanyDetailsModal } from "../panels/CompanyDetailsModal";
import { useList } from "./useList";

export const List = (): JSX.Element => {
  const {
    dataGridColumns,
    isLoading,
    onAddCompanyClick,
    onCloseAddEditCompanyModal,
    onCloseCompanyDetailsModal,
    onEditCompanyClick,
    onBackToDetails,
    onDataGridChange,
    onCompanySaved,
    onCompanyDeleted,
    fetchCompanyByUuid,
    refreshCompaniesGrid,
    selectedCompanyUuid,
    showCompanyDetailsModal,
    companyFormMode,
    showAddEditCompanyModal,
  } = useList();

  return (
    <div className="TemplateTabCard OperationsCompaniesCard">
      <Row spacingV="m">
        <Column span={12}>
          <div className="OperationsCompaniesHeader">
            <h2>Companies</h2>
            <Button text="Add company" onClick={onAddCompanyClick} corners="rounded" size="small" />
          </div>
        </Column>
      </Row>
      <CursorDataGrid
        columns={dataGridColumns}
        clientSide={false}
        filterable
        onChange={onDataGridChange}
        data={[]}
        dataIsLoading={isLoading}
        noDataMessage="No companies to display"
        variant="seed"
        refresh={refreshCompaniesGrid}
      />
      <AddEditCompanyModal
        show={showAddEditCompanyModal}
        onClose={onCloseAddEditCompanyModal}
        onSaved={onCompanySaved}
        mode={companyFormMode}
        companyUuid={selectedCompanyUuid}
        fetchCompanyByUuid={fetchCompanyByUuid}
        onBackToDetails={onBackToDetails}
      />
      <CompanyDetailsModal
        show={showCompanyDetailsModal}
        onClose={onCloseCompanyDetailsModal}
        companyUuid={selectedCompanyUuid}
        fetchCompanyByUuid={fetchCompanyByUuid}
        onEdit={onEditCompanyClick}
        onDeleted={onCompanyDeleted}
      />
    </div>
  );
};
